import React from "react"
import { Stack } from "@mui/material"
import PoolHeader from "./components/PoolHeader"
import { SupplyBorrow } from "@/components/dashboard/supplyBorrow"

const View = () => {
  return (
    <Stack className='flex-1 bg-white rounded-lg border border-solid border-secondary'>
      <PoolHeader />
      <Stack className='px-3 py-6 sm:p-6'>
        <SupplyBorrow />
      </Stack>
    </Stack>
  )
}

export default View
